const REQUIRED_COOKIE_CHECK_NAME = "kdrive_required_cookie_check";

function cookieAttributes(): string {
  return `Path=/; SameSite=Lax${window.location.protocol === "https:" ? "; Secure" : ""}`;
}

export function canUseRequiredCookies(): boolean {
  const attributes = cookieAttributes();

  try {
    const marker = crypto.randomUUID();
    document.cookie = `${REQUIRED_COOKIE_CHECK_NAME}=${marker}; ${attributes}; Max-Age=60`;
    return document.cookie
      .split(";")
      .map((cookie) => cookie.trim())
      .some((cookie) => cookie === `${REQUIRED_COOKIE_CHECK_NAME}=${marker}`);
  } catch {
    return false;
  } finally {
    try {
      document.cookie = `${REQUIRED_COOKIE_CHECK_NAME}=; ${attributes}; Max-Age=0`;
    } catch {
      // The diagnostic cookie could not be written, so there is no alternate cleanup path.
    }
  }
}
